import { sizeMap, borderMap, spinnerBaseMap, spinnerTopMap } from './Maps'; 

const Loading = ({
  size = '6',
  colorBase = 'purple-200',
  colorAccent = 'white',
  double = false,
  bold = '4',
  inline = false
}) => {
  const baseColor = double ? colorAccent : colorBase;
  const topColor = double ? colorBase : colorAccent;
  const safeBaseColor = String(baseColor).replace(/[^a-zA-Z0-9_-]/g, '-');
  const safeTopColor = String(topColor).replace(/[^a-zA-Z0-9_-]/g, '-');

  return (
    <div className={`flex justify-center ${inline ? 'w-auto' : 'w-full'}`}>
      <div
        className={`
          loading-spinner loading-base-${safeBaseColor} loading-top-${safeTopColor}
          rounded-full animate-spin border-solid
          ${sizeMap[size] || sizeMap[6]}
          ${borderMap[bold] || borderMap[4]}
          ${spinnerBaseMap[baseColor] || spinnerBaseMap['purple-200']}
          ${spinnerTopMap[topColor] || spinnerTopMap['white']}
        `}
      />
    </div>
  );
};

export default Loading;
